export default {
  SAVE_QRCODE: '/manage/qr-code/save',
  EDIT_QRCODE: '/manage/qr-code/update',
  GET_CODE_LIST: '/manage/qr-code/findList',
  DELETE_QRCODE: '/manage/qr-code/delete'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/qrCode.js